document.addEventListener('DOMContentLoaded', function () {
  const form = document.querySelector('form[action="/cart/add"]');

  if (form) {
    form.addEventListener('submit', function () {
      setTimeout(function () {
        window.location.href = '/checkout';
      }, 500);
    });
  }
});

document.querySelectorAll('.workshop_card').forEach(card => {
  const checkbox = card.querySelector('.mirrorCheckbox');
  const variantInput = card.querySelector('.variantId');

  if (!checkbox || !variantInput) return;

  checkbox.addEventListener('change', function() {
    const noMirror = this.dataset.no;
    const withMirror = this.dataset.yes;

    variantInput.value = this.checked ? withMirror : noMirror;
  });
});

$(document).ready(function(){

  $('.workshop_card').each(function () {
    var $card = $(this);

    function updatePrice() {
      var selectedVariant = $card.find('input[name="id"]:checked');
      var price = selectedVariant.data('price');

      if (price) {
        // var formattedPrice = (price / 100).toFixed(2);
        var formattedPrice =  Math.round(price / 100);
        $card.find('.price_value').text(formattedPrice);
      }
    }

    // initial load
    updatePrice();

    // change event
    $card.find('input[name="id"]').on('change', function () {
      updatePrice();
    });

  });

  $('.filter_btn').click(function(){

    var filter = $(this).data('filter');

    // active class
    $('.filter_btn').removeClass('active');
    $(this).addClass('active');

    // filtering
    if(filter == 'all'){
      $('.texture_item_img').fadeIn();
    } else {
      $('.texture_item_img').hide();
      $('.texture_item_img[data-category="'+filter+'"]').fadeIn();
    }

      $('.texture_filter_grid').masonry('layout');


  });


 var $grid = $('.texture_filter_grid').masonry({
  itemSelector: '.texture_item_img',
  columnWidth: '.texture_item_img',
  percentPosition: true
});

});

